<mapfre-card [singleCard]="false">
  <div class="odometer single-card-column">
    <div class="col">
      <div class="header-icon full-icon text-center">
        <ng-container *ngIf="isAcmic; else maIcon">
          <svg-odometer-svg></svg-odometer-svg>
        </ng-container>
        <ng-template #maIcon>
          <img src="assets/img/images/icon-odometer.svg" alt="odometer icon" />
        </ng-template>        
      </div>
      <div class="text-center">
        <h1 class="title-copy margin-bottom mb24">
          {{ "REQUEST_UPDATE_MILEAGE" | translate }}
        </h1>
      </div>
    </div>
    <div class="section-description font12 margin-bottom mb24 align-left ">
      <ng-container *ngIf="isAcmic; else maNotice">
        <strong> {{ "MILEAGE_DISCOUNT_1" | translate }} </strong>
        <br />
        {{ "MILEAGE_DISCOUNT_2" | translate }}
      </ng-container>
      <ng-template #maNotice>
      <div class="row notice-content">
        <app-imp-notice
        [theme]="'blue'" 
        [impText]="'MILEAGE_DISCOUNT_2' | translate"
        [informationText]="'MILEAGE_DISCOUNT_1'"
        >            
        </app-imp-notice>
      </div> 
    </ng-template>
            
    </div>

    <div class="details margin-bottom mb32">
      <h3 class="title vehicle-name">
        {{ vehicleDetails?.vehicle }}
      </h3>
    </div>

    <form
      [formGroup]="odometerForm"
      name="odometerForm"
      (ngSubmit)="odometerForm.valid && updateOdometer()"
    >
      <div class="col input-field mapfre margin-top mt24 no-padding-horizontal">
        <input
          mdbInput
          (keypress)="isNumeric($event)"
          type="text"
          id="updateMileage"
          name="updateMileage"
          class="form-control input-width"
          [formControlName]="'updateMileage'"
          [ngClass]="{ error: showError }"
          (keyup)="checkMileage()"
        />
        <mapfre-label
          [forInput]="'updateMileage'"
          [additionalClasses]="'label-left'"
          [validationCSSClass]="!showError"
          >{{ "MILEAGE" | translate }}</mapfre-label
        >
      </div>
      <div class="help-block error-block" *ngIf="showError">
        {{ errorMessage | translate }}
      </div>
      <div
        class="row margin-top mt24 margin-bottom mb16 checkbox"
        odometerForm="legal"
      >
        <div class="col">
          <input
            class="single-checkbox"
            type="checkbox"
            id="legal-checkbox"
            [formControlName]="'legalCheckMark'"
            required
          />
          <label
            class="form-check-label" [ngClass]="{'mlegal disclaimer disclaimer small': isAcmic}"
            for="legal-checkbox"
            >{{ "LEGAL_CHECKMARK" | translate }}</label
          >
        </div>
      </div>
      <div class="legal odometer-legal">
        {{ "LEGAL" | translate }}
      </div>

      <div class="col text-center margin-top mt24">
        <mapfre-button
          [ngClass]="{ custom_loader: loader }"
          [additionalClasses]="'basic primary medium-btn no-padding-horizontal'"
          [disabledValue]="odometerForm.valid"
          [inputType]="'submit'"
          [translateValue]="'UPDATE_MILEAGE' | translate"
        ></mapfre-button>
      </div>
    </form>

    <div class="col text-center  margin-top mt24">
      <mapfre-button
        additionalClasses="link-button small red-link button-border-red"
        [backIcon]="'./assets/img/icons/back-arrow-red.png'"
        [iconClasses]="'align-middle'"
        (click)="goBack()"
        [showIconsCustom]="true"
      >
        {{ "BACK" | translate }}
      </mapfre-button>
    </div>
  </div>
</mapfre-card>
